import {
  ProductTypeEnum,
  SettleValueTypeEnum,
  type InputsAndDropdownsDrawerDropdownOption,
  type Security,
} from '@talos/kyoko';

export const ALL_ASSETS_LABEL = 'All assets';
export const ALL_ASSETS_VALUE = '__ALL_ASSETS__';
export const ALL_ASSETS_OPTION = {
  value: ALL_ASSETS_VALUE,
  label: ALL_ASSETS_LABEL,
} satisfies InputsAndDropdownsDrawerDropdownOption<string>;
export const NO_ASSETS_LABEL = 'No assets';

// Initial cross-asset risk group support is limited to perps and CFDs.
// Options and futures can be added here later if the feature expands.
const LINEAR_DERIVATIVE_PRODUCT_TYPES: readonly ProductTypeEnum[] = [
  ProductTypeEnum.PerpetualSwap,
  ProductTypeEnum.CFD,
];

export function isCrossAssetRiskGroupAllAssets(asset: string | undefined): boolean {
  return asset === ALL_ASSETS_VALUE;
}

/**
 * The dropdown uses a UI-only value for the explicit All assets choice.
 * When delta risk check is enabled, the backend represents that choice as [].
 * Convert when EntityAdmin prepares the drawer record, before it checks for changed fields.
 * Sending the UI value as an asset symbol would make POST and PATCH fail.
 */
export function replaceAllAssetsSelectionWithEmptyAssets(assets: string[]): string[] {
  return assets.length === 1 && isCrossAssetRiskGroupAllAssets(assets[0]) ? [] : assets;
}

export function isCrossAssetRiskGroupLinearDerivativeSecurity(security: Security | undefined): security is Security {
  return Boolean(
    security &&
    LINEAR_DERIVATIVE_PRODUCT_TYPES.includes(security.ProductType) &&
    security.SettleValueType === SettleValueTypeEnum.Regular
  );
}
